import { render, staticRenderFns } from "./AniNumbers.vue?vue&type=template&id=a5e00fee&scoped=true&"
import script from "./AniNumbers.vue?vue&type=script&lang=js&"
export * from "./AniNumbers.vue?vue&type=script&lang=js&"
import style0 from "./AniNumbers.vue?vue&type=style&index=0&id=a5e00fee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e00fee",
  null
  
)

component.options.__file = "AniNumbers.vue"
export default component.exports